import {
  FURROW_REGANTO_FAILED,
  FURROW_REGANTO_REQUEST,
  FURROW_REGANTO_SUCCESS,
} from "app/redux/actions/SeriesProduct/FurrowReganto/constant";

const INIT_STATE = {
  loading: false,
  totalPage: 0,
  data: [],
  error: {
    isError: false,
    message: null,
  },
};

export const furrowRegantoReducer = function (state = INIT_STATE, action) {
  switch (action?.type) {
    case FURROW_REGANTO_REQUEST:
      return {
        loading: true,
        totalPage: 0,
        data: [],
        error: {
          isError: false,
          message: null,
        },
      };
    case FURROW_REGANTO_SUCCESS:
      return {
        loading: false,
        data: action?.payload?.data,
        totalPage: action?.payload?.totalPage,
        error: {
          isError: false,
          message: null,
        },
      };
    case FURROW_REGANTO_FAILED:
      const { isError = true, message = "Something Went Wrong" } =
        action?.payload?.error || {};
      return {
        loading: false,
        totalPage: 0,
        data: [],
        error: {
          isError: isError,
          message: message,
        },
      };
    default:
      return state;
  }
};
